import React from 'react'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { HubspotForm } from '@/components/molecules/HubspotForm/HubspotForm'

import purpleHalfCircle from '@/assets/icons/purple_half_circle.svg'
import purpleQuarterCircle from '@/assets/icons/purple_quarter_circle.svg'
import yellowQuarterCircle from '@/assets/icons/yellow_quarter_circle.svg'
import { GatedContentSectionProps } from '@/components/organisms/GatedContentSection/types'

export function GatedContentSection({ pageContent, instance, ...props }: GatedContentSectionProps) {
  const { content } = pageContent?.blok || instance || {}
  const { heading, body, background_image, form } = content || props

  const formData = form.length && form[0]

  return (
    <section
      className="bg-primary-900 bg-center relative"
      style={{ backgroundImage: `url(${background_image?.image})`, backgroundSize: 'cover' }}
    >
      <img src={purpleHalfCircle} alt="background icon" className="absolute z-1 right-0 top-1/3 tablet:hidden" />
      <img
        src={purpleQuarterCircle}
        alt="background icon"
        className="hidden absolute z-1 tablet:block tablet:top-0 tablet:right-0"
      />
      <img src={yellowQuarterCircle} alt="background icon" className="absolute z-1 bottom-0" />
      <div
        className="flex flex-col p-24 gap-16 mx-auto
    laptop:px-90 laptop:py-64 netbook:flex-row netbook:items-center netbook:justify-between max-w-screen-desktop"
      >
        <div className="w-full mb-16 z-10">
          <h2 className="text-white text-headingM-mobile netbook:text-headingM font-bold mb-24 max-w-lg font-poppins">
            {heading}
          </h2>
          <div className="text-white leading-loose text-bodyL font-normal netbook:max-w-lg">
            {typeof body === 'string' ? body : <RichTextField data={body} />}
          </div>
        </div>
        <div className="w-full laptop:max-w-44 z-10">{formData && <HubspotForm {...formData} />}</div>
      </div>
    </section>
  )
}
